export default __webpack_public_path__ + "static/media/YAS0830.34I-37992_-25390_0.cc0c0527.jpg";